import React from 'react';
interface CloseIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function CloseIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<CloseIconProps>) {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_3995_12850)">
				<g clipPath="url(#clip1_3995_12850)">
					<path
						d="M8.127 3.272a1.556 1.556 0 00-2.19-.275 1.574 1.574 0 00-.275 2.201L14.022 16l-8.36 10.802c-.529.683-.406 1.669.274 2.2.68.533 1.661.41 2.19-.274L16 18.555l7.874 10.173c.529.683 1.51.807 2.19.275.68-.532.803-1.518.274-2.201L17.978 16l8.36-10.802c.53-.683.407-1.669-.274-2.2a1.556 1.556 0 00-2.19.274L16 13.445 8.127 3.272z"
						fill={fill}
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_3995_12850">
					<path fill="#fff" d="M0 0H32V32H0z" />
				</clipPath>
				<clipPath id="clip1_3995_12850">
					<path fill="#fff" d="M0 0H32V32H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
